module.exports = __webpack_public_path__ + "static/soon-db4c2aa2ee927464e8b3b1c9c9a0da6d.svg";